import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from "@angular/fire/database";
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-kml-generator',
  templateUrl: './kml-generator.component.html',
  styleUrls: ['./kml-generator.component.css']
})
export class KmlGeneratorComponent implements OnInit {
  constructor(private spinner: NgxSpinnerService, private firebase: AngularFireDatabase, private http: HttpClient) { }

  year_L = [    //รายการปี
    { "yearTh": "6566", "yearCr": "2223", "yearDesc": "ปี 2565/2566", set: 1, srt: 0 },
    { "yearTh": "6667", "yearCr": "2324", "yearDesc": "ปี 2566/2567", set: 1, srt: 0 },
    { "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568", set: 1, srt: 1 },
    { "yearTh": "6869", "yearCr": "2526", "yearDesc": "ปี 2568/2569", set: 2, srt: 0 },
  ]
  year_S: any;
  ngOnInit(): void {
    this.year_S = this.year_L.filter(d => d.srt == 1)[0];
  }

  getmapAll(year: any) {
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query//.limitToFirst(101)
        .orderByChild("approveSts")
        .equalTo(1)
        .once('value')
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            let rec = {
              key: childS.key,
              //...snapshot.val(),
              landno: childS.val().landno || '',
              groupCode: childS.val().groupCode || '',
              landvalue: childS.val().DetailPlant.AreaPre || '',
              CaneTypeId: childS.val().DetailPlant.CaneTypeId || '',
              CaneYearId: childS.val().DetailPlant.CaneYearId || '',
              levelArea: childS.val().DetailPlant.levelOfTheArea || [],
              ZoneId: childS.val().DetailPlant.ZoneId || '',
              plantDate: childS.val().DetailPlant.plantDate || '',
              coordinates: childS.val().coordinates || [],
              point: childS.val().coordinatesCenter || [],
              spv_profile: childS.val().spv_profile || [],
              bnm_profile: childS.val().bnm_profile || [],
              fmcode: childS.val().bnm_profile.code || '',
              fmname: (childS.val().bnm_profile.pName + childS.val().bnm_profile.name + ' ' + childS.val().bnm_profile.surname) || '',
              supcode: childS.val().spv_profile.code || '',
            }
            maps.push(rec);
          });
          console.log('rec.length : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getmapAll2(year: string) {

  }

  maps = [];
  maps_s = [];
  zone = [];
  szone = '';
  getMapall() {
    let year_S = this.year_S;
    if (year_S.set == 1) {
      this.spinner.show();
      this.getmapAll(year_S.yearCr).then((maps: any) => {
        this.spinner.hide();
        if (maps.length > 0) {
          console.log('maps.length', maps.length);
          this.maps = maps.filter((el) => (el.CaneTypeId) != 'OT' && el.spv_profile.code != '' && el.landno != '');
          //this.zone = [...new Set(this.maps.map(function (elem) { return (elem.ZoneId) }))].sort(this.compareNumbers);
          //console.log('zone: ', this.zone)
          //console.log('maps : ', maps);
        }
        else {
          alert('ข้อมูลที่เลือกไม่พบข้อมูล');
        }
      });
    }
    else if (year_S.set == 2) {
      this.spinner.show();
      //let Url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-3/select_sfw_0?f=[dbintechgen3].[dbo].[v_areas_kml]&w=CaneYearId=${year_S.yearCr} and ZoneId in ('01','02')`
      let Url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-3/select_sfw_0?f=[dbintechgen3].[dbo].[v_areas_kml]`     
      axios.get(Url).then(res => {
        this.spinner.hide();
        let data = res.data;
        if (data.length > 0) {
          let data2 = data.map(item => {
            return {
              ...item,
              point: JSON.parse(item.point),
              coordinates: JSON.parse(item.coordinates),
              //plantDate: item.plantDate.toISOString().split('T')[0] || ''
              //plantDate2: item.plantDate
            };
          });
          this.maps = data2;
        }
        else {
          alert('ข้อมูลที่เลือกไม่พบข้อมูล');
        }
      }).catch(err => { throw (err); });
    }
  }

  compareNumbers(a, b) {
    return a - b;
  }

  openJSONFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target?.result as string;
        try {
          this.maps = JSON.parse(content);
          console.log('maps.length', this.maps.length);
          this.zone = [...new Set(this.maps.map(function (elem) { return (elem.ZoneId) }))].sort(this.compareNumbers);
          console.log('zone: ', this.zone)
          //console.log('maps: ', this.maps)
        } catch (error) {
          console.error('Error parsing JSON file:', error);
        }
      };
      reader.readAsText(file);
    }
  }

  filter_data() {
    let zone = this.szone;
    let data = this.maps
    if (data.length > 0) {
      if (zone == "all") {
        this.maps_s = data;
      }
      else {
        this.maps_s = data.filter((el) => (el.ZoneId) == zone);
      }
    }
  }

  generateKML(data: any[], name: string): string {
    let kml = `<?xml version="1.0" encoding="UTF-8"?>
    <kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
        <name>${name}</name>`;

    // Define styles for different CaneTypeId values
    kml += `
        <Style id="ER-style">          
          <PolyStyle> <color>7f00ff00</color> </PolyStyle>
        </Style>
        <Style id="SR-style">          
          <PolyStyle> <color>7fff0000</color> </PolyStyle>
        </Style>
        <Style id="ST-style">          
          <PolyStyle> <color>7f0000ff</color> </PolyStyle>
        </Style>
        <Style id="DE-style">          
          <PolyStyle> <color>7fffe599</color> </PolyStyle>
        </Style>
        `;

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const entry = data[key];
        const caneTypeId: string = entry.CaneTypeId;
        // Assign the appropriate style URL based on CaneTypeId
        let styleUrl = '';
        switch (caneTypeId.slice(0, 2)) {
          case 'ER': styleUrl = '#ER-style'; break;
          case 'SR': styleUrl = '#SR-style'; break;
          case 'ST': styleUrl = '#ST-style'; break;
          default: styleUrl = '#DE-style'; break;
        }

        //console.log('entry',entry)
        kml += `
        <Placemark>
          <name>${entry.landno}</name>
          <styleUrl>${styleUrl}</styleUrl>
          <ExtendedData>
            <Data name="key"><value>${entry.key}</value>
            </Data>
            <Data name="YearId"><value>${entry.CaneYearId}</value>
            </Data>
            <Data name="landno"><value>${entry.landno || ""}</value>
            </Data>
            <Data name="fmcode"><value>${entry.fmcode || ""}</value>
            </Data>
            <Data name="fmname"><value>${entry.fmname || ""}</value>
            </Data>
            <Data name="landvalue"><value>${entry.landvalue || ""}</value>
            </Data>
            <Data name="CaneTypeId"><value>${entry.CaneTypeId || ""}</value>
            </Data>
            <Data name="ZoneId"><value>${entry.ZoneId || ""}</value>
            </Data>
            <Data name="supcode"><value>${entry.supcode || ""}</value>
            </Data>
            <Data name="levelArea"><value>${entry.levelArea || ""}</value>
            </Data>
            <Data name="lat"><value>${entry.point.lat || ""}</value>
            </Data>
            <Data name="lng"><value>${entry.point.lng || ""}</value>
            </Data>
            <Data name="plantDate"><value>${this.calculateDate(entry.plantDate) || ""}</value>
            </Data>
          </ExtendedData>
          <Polygon>
            <outerBoundaryIs>
              <LinearRing>
                <coordinates>`;

        entry.coordinates.forEach(coord => {
          kml += `${coord.lng},${coord.lat},0 `;
        });

        kml += `
                </coordinates>
              </LinearRing>
            </outerBoundaryIs>
          </Polygon>
        </Placemark>`;
      }
    }

    kml += `</Document></kml>`;
    return kml;
  }

  generateKMLFiles(): void {
    const data = this.maps_s;
    if (data) {
      let date = this.getDate();
      let year = this.year_S.yearCr;
      let zone = this.szone;
      let name = `map${year}_${date}-z-${zone}`;
      const kmlContent = this.generateKML(data, name);
      const blob = new Blob([kmlContent], { type: 'text/xml' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${name}.kml`;
      link.click();
    } else {
      console.error('No JSON data available to convert.');
    }
  }

  generateJsonFiles(): void {
    let date = this.getDate();
    let year = this.year_S.yearCr;
    let zone = this.szone;
    let name = `json${year}_${date}-z-${zone}`;
    const data = this.maps;
    const jsonContent = JSON.stringify(data, null, 2);
    const jsonBlob = new Blob([jsonContent], { type: 'application/json' });
    const jsonLink = document.createElement('a');
    jsonLink.href = URL.createObjectURL(jsonBlob);
    jsonLink.download = `${name}.json`;
    jsonLink.click();
  }

  getDate() {
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('sv-SE', options);
    return dateLOC
  }

  calculateDate(date: string): String {
    if (!date) {
      //console.log('Calculating date :', date);
      return ''
    }
    else {
      const date1 = new Date(date)
      let options: object = {
        year: "numeric", month: "2-digit", day: "2-digit", timeZone: 'UTC'
      };
      return date1.toLocaleString('sv-SE', options);
    }
  }


  //-----------------------------
  jsonData: any[] = [];

  // อ่านไฟล์ JSON
  handleFileUpload(event: Event): void {
    this.jsonData = [];
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file && file.name.endsWith('.json')) {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          let data = JSON.parse(reader.result as string);
          data = data.map(item => {
            return {
              ...item,
              point: JSON.parse(item.point),
              //coordinates: JSON.parse(item.coordinates),              
            };
          });
          this.jsonData = data;
        } catch (e) {
          console.error('Invalid JSON file');
        }
      };
      reader.readAsText(file);
    }
  }

  // สร้าง KML จาก JSON พร้อมใส่สีตาม CaneTypeName
  generateKML2(): void {
    const kml = this.convertJsonToKml(this.jsonData);

    const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'converted.kml';
    link.click();
    URL.revokeObjectURL(link.href);
  }

  // ฟังก์ชันแปลง JSON เป็น KML + สี
  convertJsonToKml(data: any[]): string {
    const getColorForType = (type: string) => {
      console.log('color:', type)
      switch (type.slice(0, 2)) {
        case 'ER': return '7f00ff00';   // เขียวอ่อน
        case 'SR': return '7f0000ff';   // น้ำเงิน
        case 'ST': return '7fff0000';   // แดง
        default: return '7faaaaaa';     // เทา
      }
    };
    let kml = `<?xml version="1.0" encoding="UTF-8"?>\n<kml xmlns="http://www.opengis.net/kml/2.2">\n<Document>\n`;

    // สร้าง Style สำหรับทุกประเภท
    const uniqueTypes = [...new Set(data.map(d => d.CaneTypeId?.trim()))];
    uniqueTypes.forEach(type => {
      const color = getColorForType(type);
      const styleId = type.replace(/\s+/g, '-');
      kml += `
        <Style id="${styleId}">
          <LineStyle><color>${color}</color><width>2</width></LineStyle>
          <PolyStyle><color>${color}</color></PolyStyle>
        </Style>`;

    });

    // สร้าง Placemark
    data.forEach((entry, idx) => {
      const coords = JSON.parse(entry.coordinates || '[]');
      const coordStr = coords.map((c: any) => `${c.lng},${c.lat},0`).join(' ');
      const styleId = (entry.CaneTypeId || '').trim().replace(/\s+/g, '-');

      kml += `
      <Placemark>
        <name>${entry.landno || ''}</name>        
        <styleUrl>#${styleId}</styleUrl>
        <ExtendedData>
            <Data name="key"><value>${entry.key}</value>
            </Data>
            <Data name="YearId"><value>${entry.CaneYearId}</value>
            </Data>
            <Data name="landno"><value>${entry.landno || ""}</value>
            </Data>
            <Data name="fmcode"><value>${entry.fmcode || ""}</value>
            </Data>
            <Data name="fmname"><value>${entry.fmname || ""}</value>
            </Data>
            <Data name="landvalue"><value>${entry.landvalue || ""}</value>
            </Data>
            <Data name="CaneTypeId"><value>${entry.CaneTypeId || ""}</value>
            </Data>
            <Data name="ZoneId"><value>${entry.ZoneId || ""}</value>
            </Data>
            <Data name="supcode"><value>${entry.supcode || ""}</value>
            </Data>
            <Data name="levelArea"><value>${entry.levelArea || ""}</value>
            </Data>
            <Data name="lat"><value>${entry.point.lat || ""}</value>
            </Data>
            <Data name="lng"><value>${entry.point.lng || ""}</value>
            </Data>
            <Data name="plantDate"><value>${entry.plantDate || ""}</value>
            </Data>
          </ExtendedData>
        <Polygon>
          <outerBoundaryIs>
            <LinearRing>
              <coordinates>${coordStr}</coordinates>
            </LinearRing>
          </outerBoundaryIs>
        </Polygon>
      </Placemark>`;
    });

    kml += `</Document>\n</kml>`;
    return kml;
  }

}
